export default __webpack_public_path__ + "static/media/bandeira_br.e650d7ca.png";